import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import MotCle from '../Entity/MotCle'

/**
* Class MotCleList
* MotCleList view component
**/
class MotCleList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = MotCle;

    // Filter list
    const filters = [{
      title: "Nom du mot-clé",
      type: "text",
      name: "libelle",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes mots-clé</h2>
        <GridFilter title="Filtrer les mots-clé" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Mots-clé" ref={"grid" + objectClass.name} path="motcles" objectPath="motcles" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + MotCle.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + MotCle.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + MotCle.name];
    grid.clearFilters();
  }

}
export default MotCleList;



// WEBPACK FOOTER //
// ./src/views/Search/MotCleList.js